import { MemberState } from '../../../types/zinantis/members/membersType';
import { readOnlyEntities } from '../../../utils/commonVariables/entityKeys';
import { buildOdataEndPoint } from '../../../utils/odataEndPoint';
import api from '../../api';
import {
    adaptAccountManagmentSegmentsToState,
    adaptMembersToState,
} from './zinantisMemberListAdapters';

//sección que han creado en prod para meter sus agencias de "test"
const FILTERED_ACCOUNT_MANAGMENT_SEGMENT_KEY = 'INTERNAL_ONLY';

export const getAccountManagmentSegments = async () => {
    const enpointOptions = {
        entity: readOnlyEntities.AccountManagementSegment,
        filter: {
            and: [
                'Enabled',
                'ForAgency',
                `Key ne '${FILTERED_ACCOUNT_MANAGMENT_SEGMENT_KEY}'`,
            ],
        },
        orderBy: 'Order asc',
        select: ['Id', 'Key', 'Name', 'LocalizedCaption', 'Caption'],
    };

    const endpoint = buildOdataEndPoint(enpointOptions);
    const { data } = await api.get(endpoint);
    return adaptAccountManagmentSegmentsToState(data?.value);
};

export const getZinantisMembers = async (): Promise<MemberState[]> => {
    const endpointOptions = {
        entity: readOnlyEntities.Agency,
        expand: [
            readOnlyEntities.AccountManagementSegment,
            readOnlyEntities.Country,
            'LogoFile',
        ],
        orderBy: 'Name asc',
        select: [
            'Id',
            'Name',
            'Address',
            'IdCountry',
            'Country/LocalizedCaption',
            'Country/Caption',
            'Country/Name',
            'Country/ISO2',
            'LogoFile/VirtualPath',
            'IdAccountManagementSegment',
            'AccountManagementSegment/LocalizedCaption',
            'AccountManagementSegment/Caption',
            'AccountManagementSegment/Name',
            'ZinantisMemberDate',
        ],
        filter: `AccountManagementSegment/Key ne '${FILTERED_ACCOUNT_MANAGMENT_SEGMENT_KEY}'`,
    };

    const endpoint = buildOdataEndPoint(endpointOptions);
    const { data } = await api.get(endpoint);
    return adaptMembersToState(data.value);
};
